import axios from "axios";
import React, { useEffect, useState } from "react";
import { UserConsumer } from "../../../UserContext";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { Table } from "../../../components/CustomPaginations";
import { tableStyle } from "../../../components/TableStyle";
import Header from "../../../components/Header";
import moment from "moment";
import FilterationBar from "./FilterationBar";
import { ViewLeaveApplication_API } from "./ViewLeaveApplication_API";
import { AlertPopups } from "../../../components/AlertPopups";
import { Redirect } from "react-router-dom";
import ButtonLoader from "../../../components/ButtonLoader";
import {
	ExcelBtnClassName,
	ExcelBtnTitle,
} from "../../ticketModule/variables/ListingVariables";

function ViewLeaveApplication() {
	let token,
		empRole = null;
	const defaultSorted = [
		{
			dataField: "leaveStartDate",
			order: "desc",
		},
	];
	const [pageNum, setPageNum] = useState(() => 1);
	const [pagerData, setPagerData] = useState(() => null);
	const [isLoading, setIsLoading] = useState(true);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(() => 10);
	const [apiHeaderToken, setApiHeaderToken] = useState(() => null);
	const [spReviewLeaveData, setSpReviewLeaveData] = useState([]);
	const [leaveTypes, setLeaveTypes] = useState(() => null);
	const [selectedLeaveType, setSelectedLeaveType] = useState(() => null);
	const [sortBy, setSortBy] = useState(() => defaultSorted[0]);
	const [employees, setEmployees] = useState(() => []);
	const [selectedEmployees, setSelectedEmployees] = useState(0);
	const [leaveStatus, setLeavesStatus] = useState(() => []);
	const [selectedstatus, setSelectedStatus] = useState(() => null);
	const [exportExcelDownloading, setExportExcelDownloading] = useState(false);

	const getColumns = [
		{
			dataField: "leaveApplicationId",
			text: "Application ID",
			sort: true,
		},
		{
			dataField: "employeeName",
			text: "Employee Name",
			sort: true,
		},
		{
			dataField: "leaveType",
			text: "Leave Type",
			sort: true,
		},
		{
			dataField: "leaveStartDate",
			text: "Start Date",
			sort: true,
			formatter: (recordData) => {
				return moment(recordData).format("DD/MM/YYYY");
			},
		},
		{
			dataField: "leaveDuration",
			text: "Leave Duration",
			sort: true,
		},
		{
			dataField: "supervisorStatus",
			text: "Supervisor Status",
			sort: true,
		},
		{
			dataField: "adminStatus",
			text: "Admin Manager Status",
			sort: true,
		},
	];

	useEffect(() => {
		let tokenHeader = {
			Authorization: `Bearer ${token}`,
		};

		if (empRole.includes("3")) setNumberOfItemsPerPage(200);

		//get leave Types
		axios
			.get(`${ViewLeaveApplication_API.GetLeaveTypes}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					const types = data.types;
					types.unshift({ value: 0, label: "All" });
					setLeaveTypes(
						types.sort((a, b) => a.label.localeCompare(b.label))
					);
					setSelectedLeaveType({ value: 0, label: "All" });
				}
			});

		//GetSupervisorEmployees
		axios
			.get(`${ViewLeaveApplication_API.GetSupervisorEmployees_API}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				const sendData = [];
				if (res) {
					res.data.forEach((item) =>
						sendData.push({
							label: item.name,
							value: item.employeeId,
						})
					);
				}
				sendData.unshift({ value: 0, label: "All" });
				setEmployees(
					sendData.sort((a, b) => a.label.localeCompare(b.label))
				);
				setSelectedEmployees({ value: 0, label: "All" });
			})
			.catch((err) => {});

		//GetLeaveStatusType
		axios
			.get(`${ViewLeaveApplication_API.GetLeaveStatusType_API}`, {
				headers: { Authorization: `Bearer ${token}` },
			})
			.then((res) => {
				const sendData = [];
				if (res) {
					res.data.statusTypes.forEach((item) =>
						sendData.push({ label: item.label, value: item.value })
					);
				}
				sendData.unshift({ value: 0, label: "All" });
				setSelectedStatus({ value: 0, label: "All" });
				setLeavesStatus(
					sendData.sort((a, b) => a.label.localeCompare(b.label))
				);
			})
			.catch((err) => {});

		//GetLeaves
		axios
			.get(
				`${
					ViewLeaveApplication_API.GetLeaves_API
				}?EmployeeId=0&LeaveType=0&LeaveStatus=0&PageSize=${
					empRole.includes("3") ? 200 : 10
				}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}`,
				{
					headers: { Authorization: `Bearer ${token}` },
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewLeaveData(res.data.leaves);
				}
			});

		setApiHeaderToken(tokenHeader);
	}, []);

	const receiveData = (PageSize) => {
		//call api on table page size change

		setIsLoading(true);
		let apiUrl = "";
		const selectedemployeevalue = selectedEmployees.value;
		const selectedleavetypevalue = selectedLeaveType.value;
		const selectedstatusvalue = selectedstatus.value;
		apiUrl = `${
			ViewLeaveApplication_API.GetLeaves_API
		}?EmployeeId=${selectedemployeevalue}&LeaveType=${selectedleavetypevalue}&LeaveStatus=${selectedstatusvalue}&PageSize=${PageSize}&PageNumber=${1}&SortBy=${
			sortBy.dataField
		}_${sortBy.order}`;

		axios
			.get(apiUrl, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewLeaveData(res.data.leaves);
				}
			});
	};

	const updateTableData = (leaveType, empId, status) => {
		//call api on table filteration
		setIsLoading(true);
		axios
			.get(
				`${ViewLeaveApplication_API.GetLeaves_API}?EmployeeId=${empId}&LeaveType=${leaveType}&LeaveStatus=${status}&PageSize=${numberOfItemsPerPage}&PageNumber=${pageNum}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: apiHeaderToken,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewLeaveData(res.data.leaves);
				}
			});
	};

	const exportToExcel = () => {
		//call api on exportToExcel button
		setExportExcelDownloading(true);
		const selectedemployeevalue = selectedEmployees.value;
		const selectedleavetypevalue = selectedLeaveType.value;
		const selectedstatusvalue = selectedstatus.value;
		axios({
			url: `${ViewLeaveApplication_API.GetExportAttendance_API}?EmployeeId=${selectedemployeevalue}&LeaveType=${selectedleavetypevalue}&LeaveStatus=${selectedstatusvalue}`, //your url
			method: "GET",
			responseType: "blob",
			headers: {
				Authorization: `Bearer ${token}`,
			},
		})
			.then((response) => {
				const url = window.URL.createObjectURL(
					new Blob([response.data])
				);
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", "EmployeeLeaveApplication.xlsx");
				document.body.appendChild(link);
				link.click();
				setExportExcelDownloading(false);
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `${err.response.data.message}`,
					});
				}
			});
	};

	const handleTableChange = async (type, { page, sortOrder, sortField }) => {
		//call api on table sorting and pagination

		try {
			setIsLoading(true);
			let getData = false;
			let apiURL = "";
			const selectedemployeevalue = selectedEmployees.value;
			const selectedleavetypevalue = selectedLeaveType.value;
			const selectedstatusvalue = selectedstatus.value;

			if (type === "pagination") {
				apiURL = `${ViewLeaveApplication_API.GetLeaves_API}?EmployeeId=${selectedemployeevalue}&LeaveType=${selectedleavetypevalue}&LeaveStatus=${selectedstatusvalue}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortBy.dataField}_${sortBy.order}`;
				getData = true;
			}
			if (type === "sort") {
				apiURL = `${ViewLeaveApplication_API.GetLeaves_API}?EmployeeId=${selectedemployeevalue}&LeaveType=${selectedleavetypevalue}&LeaveStatus=${selectedstatusvalue}&PageSize=${numberOfItemsPerPage}&PageNumber=${page}&SortBy=${sortField}_${sortOrder}`;
				setSortBy({ dataField: sortField, order: sortOrder });
				getData = true;
			}
			if (getData) {
				const res = await axios.get(apiURL, {
					headers: apiHeaderToken,
				});

				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(page);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setSpReviewLeaveData(res.data.leaves);
				}
			}
		} catch (err) {}
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empRole = userDetails.empRole;
				return empRole.includes("3") ? ( //authorization
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="View Leaves Applications"
								headerBorder="true"
							/>

							{/*Filteartion*/}

							<FilterationBar
								leaveTypes={leaveTypes}
								selectedLeaveType={selectedLeaveType}
								onLeaveTypeChange={(value) => {
									setSelectedLeaveType(value);
									updateTableData(
										value.value,
										selectedEmployees.value,
										selectedstatus.value
									);
								}}
								AllEmployees={employees}
								selectedEmployees={selectedEmployees}
								onEmployeeChange={(value) => {
									setSelectedEmployees(value);
									updateTableData(
										selectedLeaveType.value,
										value.value,
										selectedstatus.value
									);
								}}
								LeavesStatus={leaveStatus}
								selectedStatus={selectedstatus}
								onStatusChange={(value) => {
									setSelectedStatus(value);
									updateTableData(
										selectedLeaveType.value,
										selectedEmployees.value,
										value.value
									);
								}}
							/>
							<div className="d-flex justify-content-end">
								<ButtonLoader
									className={ExcelBtnClassName}
									onClick={exportToExcel}
									btnTitle={ExcelBtnTitle}
									showBtnLoading={exportExcelDownloading}
									disabled={
										!spReviewLeaveData.length ||
										exportExcelDownloading
									}
								/>
							</div>

							{/*Table with Pagination*/}

							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: spReviewLeaveData?.length,
									page: pagerData?.CurrentPage,
									sizePerPage: pagerData?.PageSize,
									paginationSize: pagerData?.PageSize,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={""}
											keyField={"leaveApplicationId"}
											columns={getColumns}
											items={spReviewLeaveData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
											adminPagination={empRole.includes(
												"3"
											)}
											loading={isLoading}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" /> //redirection
				);
			}}
		</UserConsumer>
	);
}

export default ViewLeaveApplication;
